/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_FeasibilityInputs */

const en_learn_feasibility = /** @type {(inputs: Learn_FeasibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Feasibility of a Pause](/feasibility). The feasibility of a pause in AI development.`)
};

/**
* | output |
* | --- |
* | "[Feasibility of a Pause](/feasibility). The feasibility of a pause in AI development." |
*
* @param {Learn_FeasibilityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_feasibility = /** @type {((inputs?: Learn_FeasibilityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_FeasibilityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_feasibility(inputs)
});